import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Container } from "react-bootstrap";
import { MdMapsHomeWork } from "react-icons/md";
import "./ContactUs.css";

const ContactUs = () => {
  return (
    <section className="contactUs-wrapper">
      <Container className="contact-contatiner">
        <div className="single-contact icon1">
          <div className="c-icon">
            <MdMapsHomeWork />
          </div>
          <div className="c-info text-start">
            <h4>Address</h4>
            <p>Patel janta nagar Bhagwat nagar</p>
            <p>main road patna 26</p>
            <p>Landmark:- Near Bhagwat Milan banquet</p>
          </div>
        </div>
        <div className="single-contact icon3">
          <div className="c-icon">
            <FontAwesomeIcon icon={faEnvelope} />
          </div>
          <div className="c-info text-start">
            <h4>Email</h4>
            <p>curative.physiotherapy.clinic@gmail.com</p>
{/*             <p>info@curativephysio.com</p> */}
          </div>
        </div>
        <div className="single-contact icon2">
          <div className="c-icon">
            <FontAwesomeIcon icon={faPhone} />
          </div>
          <div className="c-info text-start">
            <h4>Contact no.</h4>
            <p>+91 9693631008</p>
            <p>+91 9693631008</p>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default ContactUs;
